import React, { useState } from "react";
import { ChevronDownIcon, PcVideoIcon, MobileVideoIcon, DocIcon } from "../membershipGuideIcons";
import { FAQS } from "../membershipGuideConst";

const LINK_ICON = {
  "pc-video": PcVideoIcon,
  "mobile-video": MobileVideoIcon,
  "doc": DocIcon,
};

const FaqLinks = ({ links }) => {
  if (!links?.length) return null;
  return (
    <div className="faq-links">
      {links.map(({ type, url, label }) => {
        const Icon = LINK_ICON[type];
        return (
          <a
            key={url}
            href={url}
            onClick={(e) => { e.preventDefault(); window.parseLink(url); }}
          >
            {Icon && <Icon />}
            {label}
          </a>
        );
      })}
    </div>
  );
};

const FaqItem = ({ faq, isOpen, onToggle }) => (
  <div className={`faq-item${isOpen ? " open" : ""}`}>
    <button type="button" className="faq-q" onClick={onToggle}>
      <span className="qbadge">Q</span>
      <span className="qtxt">{faq.q}</span>
      <ChevronDownIcon className="chev" />
    </button>
    <div className="faq-a">
      <div className="faq-a-inner">
        <span>{faq.a}</span>
        {faq.links && <FaqLinks links={faq.links} />}
      </div>
    </div>
  </div>
);

const Faq = () => {
  const [openSet, setOpenSet] = useState(() => new Set([0]));

  const toggle = (i) => {
    setOpenSet((prev) => {
      const next = new Set(prev);
      if (next.has(i)) next.delete(i);
      else next.add(i);
      return next;
    });
  };

  return (
    <section className="section section-white" id="faq">
      <div className="container">
        <div className="section-title-row">
          <h2>
            <span className="num">05</span> 자주 묻는 질문
          </h2>
        </div>
        <div className="faq-list">
          {FAQS.map((faq, i) => (
            <FaqItem
              key={i}
              faq={faq}
              isOpen={openSet.has(i)}
              onToggle={() => toggle(i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
